







import { defineComponent, PropType, computed } from "@nuxtjs/composition-api";
import type { Product } from "@wemade-vsf/catalog/lib/runtime/product/types";

export default defineComponent({
  name: "ProductDetailsDescription",
  props: {
    product: {
      type: [Object, null] as PropType<Product>,
    },
  },
  setup(props) {
    const productShortDescription = computed(() => {
      if (
        props.product?.configurable_product_options_selection?.variant
          ?.short_description?.html
      ) {
        return props.product.configurable_product_options_selection.variant
          .short_description.html;
      }
      return props.product?.short_description?.html || "";
    });

    return {
      productShortDescription,
    };
  },
});
